import { default as Blvt } from './blvt'
import { default as Bswap } from './bswap'
import { default as SubAccount } from './subAccount'
import { default as Market } from './market'
import { default as Trade } from './trade'
import { default as Wallet } from './wallet'
import { default as Margin } from './margin'
import { default as Mining } from './mining'
import { default as Savings } from './savings'
import { default as Staking } from './staking'
import { default as Stream } from './stream'
import { default as Websocket } from './websocket'
import { default as Futures } from './futures'
import { default as Fiat } from './fiat'
import { default as C2C } from './c2c'
import { default as Loan } from './loan'
import { default as Pay } from './pay'
import { default as Convert } from './convert'
import { default as Rebate } from './rebate'
import { default as NFT } from './nft'
import { default as GiftCard } from './giftCard'
import { default as PortfolioMargin } from './portfolioMargin'

export default {
    Blvt,
    Bswap,
    SubAccount,
    Market,
    Trade,
    Wallet,
    Margin,
    Mining,
    Savings,
    Staking,
    Stream,
    Websocket,
    Futures,
    Fiat,
    C2C,
    Loan,
    Pay,
    Convert,
    Rebate,
    NFT,
    GiftCard,
    PortfolioMargin,
}
